import backgroundList from '@/constants/backgroundList'

export {backgroundCollection as backgroundVariantCollection} from '@/constants/backgroundList'

export default backgroundList
  .map(({id}) => ({
    id,
    probabilityWeight: 1,
  }))
